import posthog from 'posthog-js';

// Legea 506/2004 (ePrivacy) cere consimțământ opt-in explicit înainte de
// cookie-uri/analiză non-esențiale — CookieBanner.tsx e singurul loc care
// pornește tracking-ul, apelând posthog.opt_in_capturing() la accept.
export const POSTHOG_CONSENT_STORAGE_KEY = 'vanagreen_cookie_consent_v1';

export function initPosthog(): void {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) {
    // Silent no-op when the key is not configured (dev / local) — same
    // convention as initSentry().
    return;
  }
  posthog.init(key, {
    // Same-origin proxy (infra/nginx/templates/app.conf.template) — avoids
    // ad-blockers and needs no new connect-src in the CSP.
    api_host: `${window.location.origin}/ingest`,
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    // Explicit product-analytics scope only — no autocapture (risks
    // capturing operational text like waste/company/person names from the
    // DOM) and no session recording (separate GDPR consent question, out
    // of scope here). See PLAN.md's PostHog sprint for the full rationale.
    autocapture: false,
    // SPA: without this only full page loads are pageviews — 1 Oct had 101 intakes
    // created and 5 pageviews. URLs carry only ids, no names.
    capture_pageview: 'history_change',
    disable_session_recording: true,
    // No event/cookie until CookieBanner records an explicit accept.
    opt_out_capturing_by_default: true,
  });
  try {
    if (localStorage.getItem(POSTHOG_CONSENT_STORAGE_KEY) === 'accepted') {
      posthog.opt_in_capturing();
    }
  } catch {
    // localStorage unavailable — stays opted out.
  }
}

export { posthog };
